import { DeleteOutlined, EditOutlined, ExclamationCircleFilled } from '@ant-design/icons'
import { GraviButton, Horizontal } from '@gravitate-js/excalibrr'
import { Popconfirm, Tooltip } from 'antd'

export type ActionCellProps<T extends { id: string }> = {
  data: T
  handleCancel: (id: T['id']) => void
  setVisible: (visible: boolean) => void
  setSelectedRequest: (data: T) => void
}

export function ActionCell<T extends { id: string }>({
  data,
  handleCancel,
  setVisible,
  setSelectedRequest,
}: ActionCellProps<T>) {
  return (
    <Horizontal verticalCenter>
      <Tooltip title={'Edit'}>
        <GraviButton
          icon={<EditOutlined />}
          style={{ border: 'none', background: 'transparent', boxShadow: 'none' }}
          onClick={() => {
            setSelectedRequest(data)
            setVisible(true)
          }}
        />
      </Tooltip>

      <Popconfirm
        icon={<ExclamationCircleFilled style={{ color: 'var(--theme-error)' }} />}
        title={'This will cancel your order request and it will not be fulfilled. Are you sure?'}
        onConfirm={() => handleCancel(data.id)}
        placement={'topLeft'}
        cancelText={'No'}
        okText={'Yes'}
      >
        <Tooltip title={'Cancel'}>
          <GraviButton
            icon={<DeleteOutlined />}
            style={{ border: 'none', background: 'transparent', boxShadow: 'none' }}
          />
        </Tooltip>
      </Popconfirm>
    </Horizontal>
  )
}
